import OwButton from "@components/shared/OwButton/OwButton";
import OwInputWrapper from "@components/shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import { ChangeEvent, useState } from "react";

type Props = {
    confirmSubmit: () => void;
    cancelSubmit: () => void;
};

export const ConfirmWorkflowChangeModal = (props: Props) => {
    const [confirmYes, setConfirmYes] = useState("");

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        setConfirmYes(value);
    };

    return (
        <div className={"ConfirmWorkflowChangeModal container p-2"} style={{ maxWidth: "var(--bs-breakpoint-md)" }}>
            <div className={"row"}>
                <div className={"col-12"}>
                    <OwTitle leftIconName={"fad fa-exclamation-triangle"} title={"confirm"} />
                    <OwLabel className={"text-warning mt-5"} title={"order_progress_states_update_warning"} />
                    <OwLabel className={"mt-4 mb-4"} title={"type_yes_to_confirm_change"} />

                    <div className={"w-5r"}>
                        <OwInputWrapper autoFocus={true} name={"confirmYes"} value={confirmYes} fn={handleChange} className={"mb-3 mt-3"} />
                    </div>

                    <OwButton title={"save"} disabled={confirmYes !== "YES"} fn={props.confirmSubmit} />
                    <OwButton className={"btn-danger ms-2"} title={"cancel"} fn={props.cancelSubmit} />
                </div>
            </div>
        </div>
    );
};
